import css from './modal.module.css'
import { createPortal } from 'react-dom'
import { PropsWithChildren, MouseEvent } from 'react'
import CloseButton from '@/shared/Buttons/CloseButton'

interface IProps {
  title: string
  open: boolean
  onClose: () => void
  closeOnClickOutside?: boolean // default true
}

const Modal = (props: PropsWithChildren<IProps>) => {
  if (!props.open) return null

  const body = document.getElementsByTagName('body')[0]

  const handleClick = (ev: MouseEvent) => {
    if ((ev.target as HTMLDivElement).className.includes(css.shadow)) {
      props.onClose()
    }
  }

  return createPortal(
    <div className={css.shadow} onClick={props.closeOnClickOutside !== false ? handleClick : undefined}>
      <div className={css.modal}>
        <div className="text-heading-5">
          {props.title}
          <div className={css.closeWrapper}>
            <CloseButton onClick={props.onClose} />
          </div>
        </div>
        <div className="mt8">{props.children}</div>
      </div>
    </div>,
    body
  )
}

export default Modal
